import React from "react";
import ServiceCard from "../components/ServiceCard";
import Seo from "../components/Seo";
import services from "../data/services";
import "../styles/pages/services.css";

function Services() {
    return (
        <main className="page">
            <Seo
                title="Our Services"
                path="/services"
                description="Explore our services including staff recruitment and supply, mental health staff training, domiciliary care including live-in care, children's services, and secure transport."
                keywords="staff recruitment, mental health staff training, domiciliary care, live-in care, children's services, secure transport"
            />

            <div className="container services-page">
                <div className="page-header">
                    <p className="eyebrow">Our Services</p>
                    <h1>Specialist support delivered with professionalism and care</h1>
                    <p>
                        Explore our full range of professional services designed to support healthcare providers, local authorities, families, and individuals with dependable and person-centered solutions.
                    </p>
                </div>

                <div className="services-showcase">
                    <img
                        className="services-showcase__image"
                        src="https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&w=1200&q=80"
                        alt="Healthcare and care support professionals"
                    />
                </div>

                <div className="services-intro">
                    <div className="services-intro__card">
                        <h3>Tailored to your needs</h3>
                        <p>We adapt our approach to suit individual situations, service demands, and safeguarding requirements.</p>
                    </div>
                    <div className="services-intro__card">
                        <h3>Built on quality</h3>
                        <p>Every service is guided by clear standards, strong communication, and a practical focus on outcomes.</p>
                    </div>
                </div>

                <div className="card-grid services-page__grid">
                    {services.map((service) => (
                        <ServiceCard key={service.title} {...service} />
                    ))}
                </div>
            </div>
        </main>
    );
}

export default Services;